import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { createReduxStore } from "./redux/pageStore";
import ModulesRenderer from "./modulesRenderer";
import { Provider as RollbarProvider } from "@rollbar/react";

const PageWithConfigurator = ({ pageConfig, notifications, renderFilters }) => {
  const { pageName, moduleList, pageFilters = [] } = pageConfig;

  const modules = [...moduleList, ...pageFilters].map(({ moduleName, saga, reducer }) => ({
    moduleName,
    saga,
    reducer
  }));

  const store = createReduxStore(pageName, modules);

  return (
    <RollbarProvider
      config={{
        accessToken: notifications.rollbar,
        environment: notifications.env,
        payload: {
          context: pageName
        },
        enabled: notifications.env !== "development",
        captureUncaught: false,
        captureUnhandledRejections: false
      }}
    >
      <ReduxProvider store={store}>
        <ModulesRenderer pageConfig={pageConfig} renderFilters={renderFilters} />
      </ReduxProvider>
    </RollbarProvider>
  );
};

export default PageWithConfigurator;
